import { render } from "./TabBarItem.vue?vue&type=template&id=134889eb&scoped=true"
import script from "./TabBarItem.vue?vue&type=script&lang=js"
export * from "./TabBarItem.vue?vue&type=script&lang=js"

import "./TabBarItem.vue?vue&type=style&index=0&id=134889eb&scoped=true&lang=css"

import exportComponent from "D:\\建龙工作\\开发项目\\VUE程序包\\宿舍报修系统\\bxxt\\bxxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134889eb"]])

export default __exports__